import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/appUserRest/list',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/appUserRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/appUserRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/appUserRest/' + data,
    method: 'delete',
  })
}
